import { armArchitecture } from '../pages/constants';

export const isAppleSiliconImageType = (type) => type === armArchitecture;
